import { MethodTypeRepository } from '@telespot/domain';

export interface ICountMethodTypesByPipelineQuery {
  /**
   * Counts the method types that have the given pipeline assigned to them.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(pipelineId: string): Promise<number>;
}

export class CountMethodTypesByPipelineQuery implements ICountMethodTypesByPipelineQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(pipelineId: string): Promise<number> {
    return this.methodTypeRepository.countByPipeline(pipelineId);
  }
}
